import Vue from 'vue'
import moment from 'moment'
import { currency } from '@/utils/currency'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
// 金额格式化
Vue.filter("currency", currency)
// 时间戳格式化
Vue.filter("formatDate", function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr, pattern).valueOf()
})
